// extracted by mini-css-extract-plugin
export default {"root":"FeatureItem_root__pHIBp","variant1":"FeatureItem_variant1__3FLnM","variant2":"FeatureItem_variant2__dJAkT","movein":"FeatureItem_movein__x+dDg"};